/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2023.

!Changelog

2023
	10-03-2023
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/

var specific_marketing = {};

(function () {

	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************

	this.onready = function () {

		/*
		Answer
		*/
		// $(document).on('click', '.js-track-intake', function () {

		// 	//var _landing_answer 	= $(this).data('answer');

		// 	specific_marketing.sendClick(
		// 		'intake'
		// 	);

		// });

		// $(document).on('click', '.js-track-book-inleiding', function () {

		// 	//var _landing_answer 	= $(this).data('answer');

		// 	specific_marketing.sendClick(
		// 		'book-inleiding'
		// 	);

		// });

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	this.sendClick = function (
		_tracking
	) {

		$.ajax({
			url: globalUrl + '/' + url[1] + '/a/a/click-send',
			type: "POST",
			data: {
				tracking: _tracking,
				log_ref: $('.js-log_ref').val(),
				log_ads_me: $('.js-log_ads_me').val(),
				log_ads_go: $('.js-log_ads_go').val()
			},
			headers: {
				'go-load': 1
			}
		})
			.done(function (data) {

			});

	};

}).apply(specific_marketing); 